import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

import { Fancybox } from "@fancyapps/ui"

import selectize from "@selectize/selectize"

// ----- import components

// import Loader from "../blocks/components/loader/loader"
import ScrollAnimate from "./global/scroll-animate"
import Header from "../blocks/modules/header/header"
import Textarea from "../blocks/components/textarea/textarea"
import YtVideo from "../blocks/components/yt-video/yt-video"
import Tabs from "./global/tabs"
import File from "../blocks/components/file/file"
import Dropdown from "./global/dropdown"
import ServicesSlider from "../blocks/components/services-slider/services-slider"
import Partners from "../blocks/modules/partners/partners"
import Faq from "../blocks/components/faq/faq"
import FSlider from "../blocks/components/f-slider/f-slider"
import NewsSlider from "../blocks/modules/news-slider/news-slider"
import TeamSlider from "../blocks/modules/team-slider/team-slider"
import HistorySlider from "../blocks/components/history-slider/history-slider"
import ArticleNav from "../blocks/components/article-nav/article-nav"
import LicenseSlider from "../blocks/components/license-slider/license-slider"
import FeedbackForm from "../blocks/components/feedback-form/feedback-form"
import Benefits from "../blocks/components/benefits/benefits"
import ShopPartners from "../blocks/components/shop-partners/shop-partners"

// ----- import functions

import { checkCookies } from "../blocks/components/cookies/cookies"
import { scrollToId } from "./global/scrollToId"
import { copyShareLink } from "../blocks/components/share/share"
import { accordeon } from "./global/accordeon"
import { copyHTML } from "./global/copyHTML"
import { callback } from "../blocks/components/callback/callback"

// ----- env

// import { BASE_URL } from '../../env-config'

// ----- components instances

// let loader = null
let scrollAnimate = null
let header = null
let dropdown = null
let servicesSlider = null
let articleNav = null

let textarea = []
let ytVideo = []
let tabs = []
let files = []
let partners = []
let faq = []
let fslider = []
let newsSlider = []
let teamSlider = []
let historySlider = []
let licenseSlider = []
let feedbackForm = []
let benefits = []
let shopPartners = []

// ----- flags

let isMobile = false
let isFirstLoad = true

// ----- page elements

const innerHeader = document.querySelector('.js-inner-header')
const mainHeader = document.querySelector('.js-header')

function isWebp() {
  // Checking support webp
  function testWebP(callback) {
    let webP = new Image();
    webP.onload = webP.onerror = function () {
      callback(webP.height == 2);
    };
    webP.src =
      "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
  }

  testWebP(function (support) {
    let className = support == true ? "webp" : "no-webp";
    document.documentElement.classList.add(className);
  });
}

isWebp()

function checkMobile () {
  isMobile = /iPad|iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/.test(navigator.userAgent)

  if(!isMobile && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel|iPad/.test(navigator.platform)) {
    isMobile = true
  }

  if (!isMobile && window.innerWidth < 1025) {
    isMobile = true
  }

  if (isMobile) {
    document.body.classList.add('mobile')
  }
}

// ----- inject youtube api

function addYouTubeApiScripts () {
  const ytVideoItems = document.querySelectorAll(".js-yt-video");
  if (ytVideoItems.length) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    tag.setAttribute('data-swup-ignore-script', true)
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}

// ----- events

window.addEventListener('load', () => {
  onLoad()
})

document.addEventListener('DOMContentLoaded', () => {
  onReady()
})

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
} else {
  window.onbeforeunload = function () {
      window.scrollTo(0, 0);
  }
}

window.onYouTubeIframeAPIReady = () => {
  const ytItems = document.querySelectorAll(".js-yt-video");
  if ( ytItems.length ) {
    ytItems.forEach ( (el, i) => {
      ytVideo[i] = new YtVideo(el)
    })
  }
}


// ----- on window load

const onLoad = () => {
  
  isFirstLoad = false
  
  if (innerHeader) {
    mainHeader.classList.add('loaded')
    setTimeout(() => {
      innerHeader.setAttribute('data-animated', 'true')
      setTimeout(() => {
        scrollAnimate.init()
      }, 600)
    }, 300)
  } else {
    mainHeader.classList.add('loaded')
    scrollAnimate.init()
  }

  addYouTubeApiScripts()
}

// ----- on document ready. Call once on first time load

function onReady () {
  checkMobile()
  checkCookies()
  scrollToId()
  copyShareLink()
  callback()

  // ----- init components

  $(document).on('click', '[data-modal-open]', e => {
    e.preventDefault()
    const target = e.target.closest('[data-modal-open]')
    const id = target.getAttribute('data-modal-id')
    const modal = document.querySelector(id)
    const modals = document.querySelectorAll('.js-modal')

    modals.forEach(el => {
      el.classList.remove('active')
    })

    if (modal) {
      modal.classList.add('active')
      document.body.classList.add('block-scroll')
    }
  })
  
  $(document).on('click', '[data-modal-close]', e => {
    e.preventDefault()
    const target = e.target
    const modal = target.closest('.js-modal')

    if (modal) {
      modal.classList.remove('active')
      document.body.classList.remove('block-scroll')
    }
  })

  init()
}

// ----- init components

function init () {

  accordeon()
  copyHTML()

  const selectizeItems = document.querySelectorAll('.js-selectize')

  if (selectizeItems.length) {
    selectizeItems.forEach(el => {
      $(el).selectize({
        plugins: ["auto_position"]
      })
    })
  }

  $(".selectize-input input").attr('readonly','readonly');

  scrollAnimate = new ScrollAnimate()

  const headerElement = document.querySelector('.js-header')
  if (headerElement) {
    header = new Header(headerElement)
    header.init()
  }

  const textareaEl = document.querySelectorAll('.js-textarea')

  if ( textareaEl.length ) {
    textareaEl.forEach((el, i) => {
      textarea[0] = new Textarea(el)
    })
  }

  const tabsItems = document.querySelectorAll('.js-tabs')

  if (tabsItems.length) {
    tabsItems.forEach((el, i) => {
      tabs[i] = new Tabs(el)
    })
  }

  const fileItems = document.querySelectorAll('.js-file')

  if (fileItems.length) {
    fileItems.forEach((el, i) => {
      files[i] = new File(el)
    })
  }

  dropdown = new Dropdown()

  const servicesSliderItem = document.querySelector('.js-services-slider')

  if (servicesSliderItem) {
    servicesSlider = new ServicesSlider(servicesSliderItem)
    servicesSlider.init()
  }

  const partnersItems = document.querySelectorAll('.js-partners')

  if (partnersItems.length) {
    partnersItems.forEach((el, i) => {
      partners[i] = new Partners(el)
      partners[i].init()
    })
  }
  
  const faqItems = document.querySelectorAll('.js-faq')

  if (faqItems.length) {
    faqItems.forEach((el, i) => {
      faq[i] = new Faq(el)
      faq[i].init()
    })
  }
  
  const fsliderItems = document.querySelectorAll('.js-f-slider')

  if (fsliderItems.length) {
    fsliderItems.forEach((el, i) => {
      fslider[i] = new FSlider(el)
      fslider[i].init()
    })
  }
  
  const newsSliderItems = document.querySelectorAll('.js-news-slider')

  if (newsSliderItems.length) {
    newsSliderItems.forEach((el, i) => {
      newsSlider[i] = new NewsSlider(el)
      newsSlider[i].init()
    })
  }
  
  const teamSliderItems = document.querySelectorAll('.js-team-slider')

  if (teamSliderItems.length) {
    teamSliderItems.forEach((el, i) => {
      teamSlider[i] = new TeamSlider(el)
      teamSlider[i].init()
    })
  }
  
  const historySliderItems = document.querySelectorAll('.js-history-slider')

  if (historySliderItems.length) {
    historySliderItems.forEach((el, i) => {
      historySlider[i] = new HistorySlider(el)
      historySlider[i].init()
    })
  }
  
  const licenseSliderItems = document.querySelectorAll('.js-license-slider')

  if (licenseSliderItems.length) {
    licenseSliderItems.forEach((el, i) => {
      licenseSlider[i] = new LicenseSlider(el)
      licenseSlider[i].init()
    })
  }
  
  const feedbackFormItems = document.querySelectorAll('.js-feedback-form')

  if (feedbackFormItems.length) {
    feedbackFormItems.forEach((el, i) => {
      feedbackForm[i] = new FeedbackForm(el)
      feedbackForm[i].init()
    })
  }
  
  const benefitsItems = document.querySelectorAll('.js-benefits')

  if (benefitsItems.length) {
    benefitsItems.forEach((el, i) => {
      benefits[i] = new Benefits(el)
      benefits[i].init()
    })
  }

  const gallery = document.querySelectorAll('.js-gallery')

  if (gallery.length) {
    gallery.forEach(el => {
      Fancybox.bind(el, '[data-fancybox="gallery"]', {
        Images: {
          initialSize: 'fit',
          Panzoom: {
            maxScale: 2
          }
        }
      })
    })
  }

  const articleNavEl = document.querySelector('.js-article-nav')

  if (articleNavEl) {
    articleNav = new ArticleNav(articleNavEl)
    articleNav.init()
  }

  const shopPartnersItems = document.querySelectorAll('.js-shop-partners')

  if (shopPartnersItems.length) {
    shopPartnersItems.forEach((el, i) => {
      shopPartners[i] = new ShopPartners(el)
      shopPartners[i].init()
    })
  }

  if (!isFirstLoad) {

    const ytItems = document.querySelectorAll(".js-yt-video");
    if ( ytItems.length ) {
      ytItems.forEach ( (el, i) => {
        ytVideo[i] = new YtVideo(el)
      })
    }

  }
}

